import { SERVER_METHODS, requestServer, requestServerV2 } from "./request";

const path = "/genericapi";
const getSupplyCoreBaseUrl = () => {
  const sandbox = localStorage.getItem("sc-sandbox");
  const baseUrl = process.env.REACT_APP_SUPPLY_CORE_BASE_URL;
  if (!sandbox) return baseUrl;
  return baseUrl.replace("://", `://${sandbox}-`);
};

// Same sandbox transformation for V2 auth endpoints (/auth/session, /auth/login, etc.)
export const getSupplyCoreAuthBaseUrl = () => {
  const sandbox = localStorage.getItem("sc-sandbox");
  const baseUrl = process.env.REACT_APP_SUPPLY_CORE_AUTH_BASE_URL || 'https://supply-core.dev.kavida.ai/api/v2';
  const result = sandbox ? baseUrl.replace("://", `://${sandbox}-`) : baseUrl;
  return result;
};
const onboardingBaseEndpoint = process.env.REACT_APP_ONBOARD_BASE_URL;

export const getSidebarMenu = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const getGlobalNews = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSuppliersAffected = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const getMetrics = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSuppliers = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const suppliersDisruption = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const suppliersDelayOverview = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const commodityList = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const sendUpdateRequest = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const milestoneTracker = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const formUpdates = async (payload) => {
  let path = "/public/genericapi";
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const mileStoneComplete = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const sendMessageSupCommn = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const retriveMessageSupCommn = async (payload) => {
  try {
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const UJValidateRegistrationForm = async (payload) => {
  try {
    let path = "/public/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const UJRegisterNewCompany = async (payload) => {
  try {
    let path = "/auth";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const UJAvailableLocation = async (payload) => {
  try {
    let path = "/auth";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const GenerateDummyPo = async (payload) => {
  try {
    let path = "/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const UJFirstTimeLogin = async (payload) => {
  try {
    let path = "/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const onBoardingRequest = async (payload) => {
  try {
    let path = "/onboarding";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const addEditContact = async (payload) => {
  try {
    let path = "/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
}

export const userOnboardingPublicApi = async (payload) => {
  try {
    let path = "/public/genericapi";
    let res = await requestServer(SERVER_METHODS.POST, path, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const getSidebarMenuV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      const body = await res.json().catch(() => null);
      throw new Error(`[getSidebarMenuV2] HTTP ${res.status} for ${payload.api_name}${body ? ': ' + JSON.stringify(body) : ''}`);
    }
  } catch (error) {
    console.error('[api.service] getSidebarMenuV2 error:', error);
  }
};

export const UJValidateRegistrationFormV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, onboardingBaseEndpoint, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const copilotAgentSupplyCore = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      const body = await res.json().catch(() => null);
      throw new Error(`[copilotAgentSupplyCore] HTTP ${res.status} for ${payload.api_name}${body ? ': ' + JSON.stringify(body) : ''}`);
    }
  } catch (error) {
    console.error('[api.service] copilotAgentSupplyCore error:', error);
  }
};

export const getMetricsV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const intelligenceApiServiceV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const suppliersDelayOverviewV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const milestoneTrackerV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const supplierCommunicationApiServiceV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};
 export const dmsApiServiceV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, getSupplyCoreBaseUrl(), payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};

export const onboardingRequestV2 = async (payload, method = "POST") => {
  try {
    let res = await requestServerV2(method, onboardingBaseEndpoint, payload);
    if (res.status === 200) {
      return await res.json();
    } else {
      throw new Error(res.status, await res.json());
    }
  } catch (error) {
    console.log(error);
  }
};
